module.exports = __webpack_public_path__ + "img/今日促销.png";